import api from "@/config/api"
import { withLoading } from "@/store/helpers"

const buildParams = (state) => ({
  q: state.filters.q,
  organization_id: state.filters.organizationId,
  include_blocked: state.filters.includeBlocked,
  page: state.pagination.page,
  per_page: state.pagination.perPage,
})

export default {
  namespaced: true,
  state: () => ({
    users: [],
    filters: {
      q: "",
      organizationId: null,
      includeBlocked: false,
    },
    pagination: {
      page: 1,
      perPage: 20,
    },
    loading: false,
  }),
  mutations: {
    setUsers(state, users) {
      state.users = users
    },
    setFilters(state, payload) {
      state.filters = { ...state.filters, ...payload }
    },
    setPagination(state, payload) {
      state.pagination = { ...state.pagination, ...payload }
    },
    resetFilters(state) {
      state.filters = { q: "", organizationId: null, includeBlocked: false }
      state.pagination = { page: 1, perPage: 20 }
    },
    setLoading(state, loading) {
      state.loading = loading
    },
  },
  actions: {
    async fetchUsers(context) {
      return withLoading(async () => {
        const response = await api.get("/maestro/users", { params: buildParams(context.state) })
        context.commit("setUsers", response.data)
      }, context)
    },
  },
}
